import type { Translate } from 'next-translate';

import {
    platform_language,
    homepage,
    validate_auto_publishing_mobile_app,
    enable_notifications,
    numbers_format,
    time_format,
    date_format,
    first_day_week,
    beginning_q1,
    export_csv_delimiter,
    enable_weekly_digest_email,
    enable_monthly_digest_email
} from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';
import { languages_available } from '@/lib/settings/optionsConfiguration/platformSettings/languagesAvailable';
import { timezone } from '@/lib/settings/optionsConfiguration/platformSettings/timezone';

export function getPlatformSettingsOptions(t: Translate) {
    return {
        platform_language: platform_language(t),
        posts_auto_translate: languages_available(t),
        homepage: homepage(t),
        export_csv_delimiter: export_csv_delimiter(t),
        validate_auto_publishing_mobile_app: validate_auto_publishing_mobile_app(t),
        enable_notifications: enable_notifications(t),
        media_automatic_conversion: enable_notifications(t),
        timezone,
        numbers_format: numbers_format(t),
        time_format: time_format(t),
        date_format: date_format(t),
        first_day_week: first_day_week(t),
        beginning_q1: beginning_q1(t),
        enable_weekly_digest_email: enable_weekly_digest_email(t),
        enable_monthly_digest_email: enable_monthly_digest_email(t)
    };
}
